import { render } from "./password.vue?vue&type=template&id=35f64a3f"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/password.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35f64a3f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35f64a3f', __exports__)) {
    console.log('reload')
    api.reload('35f64a3f', __exports__)
  }
  
  module.hot.accept("./password.vue?vue&type=template&id=35f64a3f", () => {
    console.log('re-render')
    api.rerender('35f64a3f', render)
  })

}


export default __exports__